import { action, makeObservable, observable } from 'mobx';

export class ReportTableManager {
  constructor() {
    makeObservable(this);
  }

  @observable loadingTable = false;

  @observable reportTableData = [];

  @observable shouldReinitializeReportTableExpandedRows = false;
  @observable shouldUpdateReportTableExpandedRows = false;

  @observable reportCourseTableExpandedRowMap = new Map();
  @observable reportStandardsTableExpandedRowMap = new Map();

  @observable reportTableScoreSummaryBarCellConfig = [];

  @observable reportTableFacultyCellsConfig = [];

  @observable activeReportTablePage = 1;

  @action clearAll = () => {
    this.setLoadingTable(false);
    this.setReportTableData([]);
    this.setReportTableScoreSummaryBarCellConfig([]);
    this.setReportTableFacultyCellsConfig([]);
    this.setActiveReportTablePage(1);
  }

  @action clearExpandedReportTableRows = () => {
    this.shouldReinitializeReportTableExpandedRows = false;
    this.shouldUpdateReportTableExpandedRows = false;
    this.reportCourseTableExpandedRowMap = new Map();
    this.reportStandardsTableExpandedRowMap = new Map();
  }

  @action setLoadingTable = (toggle) => {
    this.loadingTable = toggle;
  }

  @action setReportTableData = (reportTableData) => {
    this.reportTableData = reportTableData;
  }

  @action setShouldReinitializeReportTableExpandedRows = (toggle) => {
    this.shouldReinitializeReportTableExpandedRows = toggle;
  }

  @action setShouldUpdateReportTableExpandedRows = (toggle) => {
    this.shouldUpdateReportTableExpandedRows = toggle;
  }

  /** @param {Map<string, boolean} tableExpandedRowMap `Map<elementId, isExpanded>` */
  @action setReportCourseTableExpandedRowMap = (tableExpandedRowMap) => {
    this.reportCourseTableExpandedRowMap = tableExpandedRowMap;
  }

  /** @param {Map<string, boolean>} tableExpandedRowMap `Map<standardId, isExpanded>` */
  @action setReportStandardsTableExpandedRowMap = (tableExpandedRowMap) => {
    this.reportStandardsTableExpandedRowMap = tableExpandedRowMap;
  }

  @action setReportTableScoreSummaryBarCellConfig = (reportTableScoreSummaryBarCellConfig) => {
    this.reportTableScoreSummaryBarCellConfig = reportTableScoreSummaryBarCellConfig;
  }

  @action setReportTableFacultyCellsConfig = (reportTableFacultyCellsConfig) => {
    this.reportTableFacultyCellsConfig = reportTableFacultyCellsConfig;
  }

  @action setActiveReportTablePage = (activePage) => {
    this.activeReportTablePage = activePage;
  }
}

export default new ReportTableManager();
